import * as yup from 'yup'

yup.addMethod(yup.string, 'trimmedRequired', function (message) {
  return this.test('trimmedRequired', message, function (value) {
    const { path, createError } = this
    if (!value || value.trim().length === 0) {
      return createError({ path, message })
    }
    return true
  })
})

export default yup
